module.exports = __webpack_public_path__ + "img/logo.ac37f8c5.png";